import React from "react";

function RecolectionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32.666 36.07"
      width="23.666"
      height="27.07"
    >
      <g
        id="Group_4633"
        data-name="Group 4633"
        transform="translate(-190.649 -286.748)"
      >
        <path
          id="Path_3597"
          data-name="Path 3597"
          d="M18.981,3l14.981,8.427V28.281L18.981,36.708,4,28.281V11.427L18.981,3"
          transform="translate(188 285.109)"
          fill="none"
          stroke="#959595"
          stroke-linecap="round"
          strokeLinejoin="round"
          stroke-width="2"
        ></path>
        <line
          id="Line_1172"
          data-name="Line 1172"
          x1="7.5"
          y1="3.964"
          transform="translate(192 296.536)"
          fill="none"
          stroke="#959595"
          stroke-linecap="round"
          strokeLinejoin="round"
          stroke-width="2"
        ></line>
        <line
          id="Line_1200"
          data-name="Line 1200"
          y1="3.964"
          x2="7.5"
          transform="translate(214.463 296.536)"
          fill="none"
          stroke="#959595"
          stroke-linecap="round"
          strokeLinejoin="round"
          stroke-width="2"
        ></line>
        <g
          id="Group_4533"
          data-name="Group 4533"
          transform="translate(201.046 297.647)"
        >
          <line
            id="Line_1166"
            data-name="Line 1166"
            y1="15.973"
            transform="translate(6.019 0)"
            fill="none"
            stroke="#959595"
            stroke-linecap="round"
            strokeLinejoin="round"
            stroke-width="2"
          ></line>
          <path
            id="Path_3594"
            data-name="Path 3594"
            d="M94.13,2740.32l5.935,5.116L106,2740.32"
            transform="translate(-94.13 -2728.803)"
            fill="none"
            stroke="#959595"
            stroke-linecap="round"
            strokeLinejoin="round"
            stroke-width="2"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default RecolectionIcon;
